const Addmission = () => {
	return (
	<div className="section-full p-t80 p-b50">
		<div className="container">		
			<div className="p-b30">
				<h3 className="text-uppercase">Admissions</h3>
				<div className="wt-separator-outer">
					<div className="wt-separator style-icon">
						<i className="fa fa-leaf text-black"></i>
						<span className="separator-left site-bg-primary"></span>
						<span className="separator-right site-bg-primary"></span>
					</div>
				</div>			
			</div>
			
			<p>At HPS, we emphasize both academic and extracurricular activities, ensuring a balanced, integrated approach to education. Our curriculum, based on RBSE syllabi, incorporates valuable elements from Indian and Western teaching systems. Co-curricular activities are integral to our teaching, complementing and expanding on the curriculum. </p>
			<p>These activities include debates, group discussions, seminars, excursions, and one-on-one interactive sessions with teachers.</p>
			<p>Extracurricular activities explore and develop students’ interests and skills beyond academics. We offer a wide range of options, including indoor and outdoor sports, dramatics, music, dance, social welfare activities, and painting. Special hobby clubs and student-run workshops, guided by teachers, teach teamwork and leadership. </p>
			<p>Additionally, workshops in electronics, wood and clay craft, computer-aided design, and gardening help students develop practical skills for future careers.</p>
			<p>Our career-orientation program identifies and nurtures each student’s unique talents. Through early guidance and support from counselors and faculty, we help students build personalized career paths.</p>
		</div>
	</div>
	);
};
export default Addmission;